import { confirmSignUp } from '@/_services/amplify.service.js'
import { mapActions } from 'vuex'
export default {
  render () {
    return null
  },
  name: 'Verify',
  mounted () {
    if (this.$route.query.t === 'createAccount') {
      confirmSignUp(this.$route.query.u, this.$route.query.c).then((user) => {
        this.$router.push({ path: '/login', params: { isFirstLoginUser: user } })
        this.showSnackbar({ message: 'Verified', color: 'success' })
      }).catch((error) => {
        console.error(error)
        this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
        this.$router.push({ path: '/login' })
      })
    } else if (this.$route.query.t === 'addUser') {
      this.$router.push({ name: 'Login', params: { isFirstLoginUser: true, verifyUsername: this.$route.query.u, verifyCode: this.$route.query.c } })
    } else {
      this.$router.push({ path: '/login' })
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    })
  }
}
